import React from 'react';
import TextAreaField from '../../../components/Forms/Input/TextAreaField';
import DetailModalWrapper from '../Common/DetailModalWrapper';
import { useScrollLock } from '../../../hooks/useScrollLock';
import { useEscapeKey } from '../../../hooks/useEscapeKey';

interface DocumentViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  document: any; // Compra o Venta
  type: 'purchase' | 'sale';
  title?: string;
  columns: any[];
  HeaderView: React.FC<{ data: any }>;
  ProductsTable: React.FC<{ columns: any[]; data: any[]; noDataMessage: string }>;
  PaymentConditionSection?: React.FC;
  ExtraInfoSection?: React.FC;
}

const DocumentViewModal: React.FC<DocumentViewModalProps> = ({
  isOpen,
  onClose,
  document,
  title = 'Detalle del Documento',
  columns,
  HeaderView,
  ProductsTable,
  PaymentConditionSection,
  ExtraInfoSection,
}) => {

  useScrollLock(isOpen);
    useEscapeKey(() => {
      if (isOpen) onClose();
    });

  return (
    <DetailModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth="max-w-6xl"
    >
      <div className="text-gray-800 dark:text-gray-100 text-sm">
        {/* 🧾 Encabezado */}
        <HeaderView data={document} />

        {/* 📦 Productos */}
        <ProductsTable
          columns={columns}
          data={document.products || []}
          noDataMessage="No hay productos registrados."
        />

        {/* 💳 Condiciones de pago */}
        {PaymentConditionSection && <PaymentConditionSection />}

        {/* 🧾 Información extra (importación u otros) */}
        {ExtraInfoSection && <ExtraInfoSection />}

        {/* 🔒 Razón de anulación (vista) */}
        {document.cancellationReason &&  (
          <div className="mt-6 space-y-6 rounded border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
            <TextAreaField
              name="cancellationReason"
              label="Razón de Anulación"
              placeholder="Motivo por el cual se anuló este documento"
              value={document.cancellationReason}
              onChange={() => {}}
              iconKey='edit'
              disabled
            />
          </div>
        )}
      </div>
    </DetailModalWrapper>
  );
};

export default DocumentViewModal;
